import {AdminRoleAttributes} from "../attributes/admin-role-attributes";
import BaseModel from "./BaseModel";

class AdminRole extends BaseModel{
  id: number;
  role: string;

  constructor(id: number, role: string) {
    super(null);

    this.id = id;
    this.role = role;
  }

  static fromJson(json: AdminRoleAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new AdminRole(json.id, json.role);
  }
}

export default AdminRole;
